<template>
  <!-- w-36 h-36 -->
  <path
    d='M30.0644 31.5H5.9356C3.62856 31.5 2.1849 29.0046 3.33489 27.0047L15.3993 6.02303C16.5528 4.01691 19.4472 4.0169 20.6007 6.02301L32.6652 27.0047C33.8151 29.0046 32.3715 31.5 30.0644 31.5Z'
    stroke='#FF8A35' stroke-width='1.5' stroke-linecap='round' />
  <path d='M18 13.5V19.5' stroke='#FF8A35' stroke-width='1.5' stroke-linecap='round' />
  <path d='M18 25.5154L18.0154 25.4983' stroke='#FF8A35' stroke-width='1.5' stroke-linecap='round'
        stroke-linejoin='round' />
</template>
